import { useEffect, useState } from "react";
import { 
    getConfigurationsTestsByCompanyId, 
    updateConfigurationsTests
} from "../../../../features/search/service/config-tests";
import { getMe } from "../../../../features/search/service/user-service";
import { getLanguagesSelect } from "../../../../features/search/service/languages-service";
import { User } from "../../../../shared/types/user";
import { SelectOption } from "../../../../shared/types/select-options";
import InputComponent from "../../../../components/input/input";
import ButtonComponent from "../../../../components/button/button";
import SelectComponent from "../../../../components/input/select";
import { MenuTop } from '../../../../components/menu/top/menu-top';
import { useNavigate, useParams } from "react-router-dom";
import './styles/edit.css';
import ButtonSecondaryComponent from "../../../../components/button-secondary/button";

export const AdminConfigsEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const [me, setMe] = useState<User | null>(null);
    const [firstValue, setFirstValue] = useState<string>('');
    const [secondValue, setSecondValue] = useState<string>('');
    const [currency, setCurrency] = useState<string>('');
    const [languageId, setLanguageId] = useState<string>('');
    const [languages, setLanguages] = useState<SelectOption[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingData, setLoadingData] = useState<boolean>(true);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userData = await getMe();
                setMe(userData);
            } catch (error) {
                console.error('❌ Erro ao buscar dados do usuário:', error);
            }
        };
        fetchUser();
    }, []);

    useEffect(() => {
        if (!me || !id) return;

        const fetchData = async () => {
            try {
                setLoadingData(true);

                const languagesData = await getLanguagesSelect();
                setLanguages(languagesData);

                if (me.company?.id) {
                    const configsTests = await getConfigurationsTestsByCompanyId(me.company.id);
                    
                    const configToEdit = configsTests.find((config: any) => String(config.id) === id);
                    
                    if (configToEdit) {
                        setFirstValue(configToEdit.firstValue || '');
                        setSecondValue(configToEdit.secondValue || '');
                        setCurrency(configToEdit.currency || '');
                        
                        const langId = configToEdit.language_id;
                        setLanguageId(langId);
                    } else {
                        alert('Configuração não encontrada');
                        navigate('/admin-configs-list');
                    }
                }
            } catch (error) {
                console.error('❌ Erro ao buscar dados:', error);
                alert('Erro ao carregar configuração');
            } finally {
                setLoadingData(false);
            }
        };

        fetchData();
    }, [me, id]);

    const updateConfig = async () => {
        if (!firstValue || !secondValue || !currency || !languageId) {
            alert('Por favor, preencha todos os campos!');
            return;
        }

        if (!id) {
            alert('Erro: ID da configuração não encontrado!');
            return;
        }

        const payload = {
            id,
            firstValue,
            secondValue,
            currency,
            languageId: languageId
        };

        setLoading(true);

        try {
            await updateConfigurationsTests(payload);
            
            navigate('/admin-configs-list');
        } catch (error) {
            console.error('❌ Erro ao atualizar configuração:', error);
            alert('Erro ao atualizar configuração. Verifique os dados e tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    if (loadingData) {
        return (
            <div>
                <MenuTop />
                <div className="configs-container">
                    <h1>Carregando configuração...</h1>
                </div>
            </div>
        );
    }
    
    return (
        <div>
            <MenuTop />
            <div className="configs-container">
                <h1>Editar Configuração</h1>
                
                <InputComponent 
                    id="id-input-firstValue" 
                    label="Valor Atrasado" 
                    value={firstValue} 
                    onChange={(event) => setFirstValue(event.target.value)} 
                />
                
                <InputComponent 
                    id="id-input-secondValue" 
                    label="Valor Adiantado" 
                    value={secondValue} 
                    onChange={(event) => setSecondValue(event.target.value)} 
                />
                
                <InputComponent 
                    id="id-input-currency" 
                    label="Moeda" 
                    value={currency} 
                    onChange={(event) => setCurrency(event.target.value)}
                />
                
                    <SelectComponent
                        label="Idioma"
                        value={languageId}
                        onChange={(value) => {
                            console.log('📋 Idioma selecionado:', value);
                            setLanguageId(String(value));
                        }}
                        options={languages}
                        styles={{ marginTop: '10px' }}
                    />

                <div className="button-container">
                    <ButtonSecondaryComponent 
                        label="Cancelar"
                        onClick={() => navigate('/admin-painel/list-configs')}
                    />
                    <ButtonComponent
                        label={loading ? "Salvando..." : "Salvar Alterações"}
                        onClick={updateConfig}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    );
}